// src/components/intake/IntakeNudges.js
//
// Ticket 064 (screen 3.4). Gentle "you told us X but we see no matching income"
// notes from the server's suggestions.comparison. Advice only: nothing here is
// stored, dismissing is in memory, and nothing blocks Next.

import React from 'react'
import { MAJOR_EVENT_OPTIONS, nudgeText } from '../../lib/intake/intakeConfig'
import { cardConfigFor } from '../../lib/intake/incomeCardMapper'
import { nudgeKey } from '../../lib/intake/section23Facts'

export default function IntakeNudges({ nudges, onDismiss }) {
  return (
    <div className="u-stack-sm">
      {nudges.map((n) => {
        const event = MAJOR_EVENT_OPTIONS.find((o) => o.value === n.event)
        const card = cardConfigFor(n.income_type)
        if (!event || !card) return null
        return (
          <div key={nudgeKey(n)} className="intake-nudge">
            <p>{nudgeText(event.label, card.label)}</p>
            <button type="button" className="btn-secondary" onClick={() => onDismiss(nudgeKey(n))}>Dismiss</button>
          </div>
        )
      })}
    </div>
  )
}
